import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class CookieService {
  public inited: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public functionalAccepted: BehaviorSubject<boolean> = new BehaviorSubject(
    false
  );

  /** Appends the CookieFirst script */
  load() {
    if (environment.config.cookieFirstKey) {
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.async = true;
      script.src = `https://consent.cookiefirst.com/sites/${environment.config.cookieFirstKey}/consent.js`;
      document.body.appendChild(script);
    }
  }
}
